type Props = {
  displayName?: string | null;
};

export default function PersonaSlot({ displayName }: Props) {
  const name = displayName ?? 'this person';
  return (
    <section className="persona-slot" aria-labelledby="persona-slot-heading">
      <header className="persona-slot__header">
        <h3 id="persona-slot-heading">Talk to {name}</h3>
        <span className="persona-slot__badge">Coming soon</span>
      </header>
      <button type="button" className="persona-slot__cta" disabled>
        Start conversation
      </button>
      <p className="persona-slot__hint">
        Conversational personas are coming in a later phase. The data model
        already reserves space for this feature.
      </p>
    </section>
  );
}
